export class InsightsRoutesI18n {
    public static readonly Insights = 'Insights';
    public static readonly CustomersByExposure = 'Customers By Exposure';
}
